import { render, staticRenderFns } from "./MyPowerStationOne.vue?vue&type=template&id=3887528c&scoped=true&"
import script from "./MyPowerStationOne.vue?vue&type=script&lang=js&"
export * from "./MyPowerStationOne.vue?vue&type=script&lang=js&"
import style0 from "./MyPowerStationOne.vue?vue&type=style&index=0&id=3887528c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3887528c",
  null
  
)

export default component.exports